/**
 * Utility to handle scroll functionality in the application
 */

// Store the scroll container reference
let scrollContainerRef: HTMLElement | null = null;

/**
 * Set the scroll container reference
 */
export const setScrollContainer = (container: HTMLElement) => {
  scrollContainerRef = container;
};

/**
 * Scroll to top of the container
 */
export const scrollToTop = (options?: ScrollBehavior) => {
  if (scrollContainerRef) {
    scrollContainerRef.scrollTo({
      top: 0,
      behavior: options || 'smooth'
    });
  }
};
